import React, { useEffect, useState } from 'react';
import { Accessibility, Type, Link as LinkIcon, TypeOutline, RotateCcw, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function AccessibilityWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [largeText, setLargeText] = useState(false);
  const [highlightLinks, setHighlightLinks] = useState(false);
  const [readableFont, setReadableFont] = useState(false);
  useEffect(() => {
    if (largeText) document.body.classList.add('a11y-large-text');else document.body.classList.remove('a11y-large-text');
    if (highlightLinks) document.body.classList.add('a11y-highlight-links');else document.body.classList.remove('a11y-highlight-links');
    if (readableFont) document.body.classList.add('a11y-readable-font');else document.body.classList.remove('a11y-readable-font');
  }, [largeText, highlightLinks, readableFont]);
  const reset = () => {
    setLargeText(false);
    setHighlightLinks(false);
    setReadableFont(false);
  };
  return <div className="fixed bottom-6 right-6 z-[100]" data-id="element-10">
      <AnimatePresence data-id="element-11">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="absolute bottom-16 right-0 w-72 bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden" data-id="element-12">
            <div className="bg-[#0F2C59] text-white p-4 flex justify-between items-center" data-id="element-13">
              <h3 className="font-bold flex items-center gap-2" data-id="element-14">
                <Accessibility size={18} data-id="element-15" />
                Accessibility Menu
              </h3>
              <button onClick={() => setIsOpen(false)} className="hover:bg-white/20 p-1 rounded-full transition-colors" aria-label="Close Accessibility Menu" data-id="element-16">
                <X size={18} data-id="element-17" />
              </button>
            </div>
            <div className="p-4 space-y-2" data-id="element-18">
              <button onClick={() => setLargeText(!largeText)} className={`w-full flex items-center gap-3 p-3 rounded-lg border transition-colors ${largeText ? 'bg-teal-50 border-[#0D9488] text-[#0F2C59]' : 'border-slate-100 hover:bg-slate-50 text-slate-700'}`} aria-pressed={largeText} data-id="element-19">
                <Type size={18} className={largeText ? 'text-[#0D9488]' : ''} data-id="element-20" />
                <span className="font-medium text-sm" data-id="element-21">Larger Text</span>
              </button>

              <button onClick={() => setHighlightLinks(!highlightLinks)} className={`w-full flex items-center gap-3 p-3 rounded-lg border transition-colors ${highlightLinks ? 'bg-teal-50 border-[#0D9488] text-[#0F2C59]' : 'border-slate-100 hover:bg-slate-50 text-slate-700'}`} aria-pressed={highlightLinks} data-id="element-22">
                <LinkIcon size={18} className={highlightLinks ? 'text-[#0D9488]' : ''} data-id="element-23" />
                <span className="font-medium text-sm" data-id="element-24">Highlight Links</span>
              </button>

              <button onClick={() => setReadableFont(!readableFont)} className={`w-full flex items-center gap-3 p-3 rounded-lg border transition-colors ${readableFont ? 'bg-teal-50 border-[#0D9488] text-[#0F2C59]' : 'border-slate-100 hover:bg-slate-50 text-slate-700'}`} aria-pressed={readableFont} data-id="element-25">
                <TypeOutline size={18} className={readableFont ? 'text-[#0D9488]' : ''} data-id="element-26" />
                <span className="font-medium text-sm" data-id="element-27">Readable Font</span>
              </button>
            </div>
            <div className="p-4 bg-slate-50 border-t border-slate-100" data-id="element-28">
              <button onClick={reset} className="w-full flex items-center justify-center gap-2 py-2 text-sm font-bold text-[#4F709C] hover:text-[#0F2C59] transition-colors" data-id="element-29">
                <RotateCcw size={16} data-id="element-30" />
                Reset Settings
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      <button onClick={() => setIsOpen(!isOpen)} className="bg-[#0D9488] hover:bg-[#0F766E] text-white p-4 rounded-full shadow-xl hover:shadow-2xl transition-all flex items-center justify-center" aria-label="Toggle Accessibility Menu" data-id="element-31">
        <Accessibility size={28} data-id="element-32" />
      </button>
    </div>;
}